// extracted by mini-css-extract-plugin
module.exports = {"root":"Shell_root__bKz9r","main":"Shell_main__TPV_F","header":"Shell_header__xx_XW","navbar":"Shell_navbar__Lpa9D"};